import { compress, urltoBlob } from 'image-conversion';
import { getFileExt, getFileUrl } from '../firebase/StorageService';
import { arrayBufferToBase64 } from './base64Utils';
import { convertHeicFamilyBlobToJpeg, isHeicFamilyExtension } from './heicUtils';
import { isListNotEmpty, isStringNotEmpty } from './objectUtils';

// Builds the base64 jpeg payload Beluga expects from stored file refs.
// One bad image must never reject the whole batch: a stored file that can't be
// decoded would otherwise permanently block the encounter sync retry loop.
// Callers get failedRefIds back so they can log/report what was skipped.
export const buildBase64Images = async (imageRefIds) => {
    const base64Images = [];
    const failedRefIds = [];

    if (!isListNotEmpty(imageRefIds)) {
        return { base64Images, failedRefIds };
    }

    for (const imageRefId of imageRefIds) {
        try {
            const ext = getFileExt(imageRefId);
            const url = await getFileUrl(imageRefId);
            let blob = await urltoBlob(url);

            if (isHeicFamilyExtension(ext)) {
                blob = await convertHeicFamilyBlobToJpeg(blob);
            }

            const compressedBlob = await compress(blob, {
                quality: 0.8,
                type: 'image/jpeg',
                width: 1000
            });
            const arrayBuffer = await compressedBlob.arrayBuffer();
            const base64Image = arrayBufferToBase64(arrayBuffer);
            if (isStringNotEmpty(base64Image)) {
                base64Images.push(base64Image);
            } else {
                failedRefIds.push(imageRefId);
            }
        } catch (err) {
            console.log(`buildBase64Images: skipping ${imageRefId}`, err);
            failedRefIds.push(imageRefId);
        }
    }

    return { base64Images, failedRefIds };
};
